import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  TextInputField,
} from "../../../../../../components/atoms";
import { BlackAndWhite } from "../../../../../../themes/Colors";

const CartItem = ({
  index,
  item,
  NameAssemble,
  EditQty,
  AddBackToProducts,
  removeFromRecipets,
}) => {
  const [qty, setQty] = useState(1);

  //   EditQty({ idIndex: index, qty: qty });
  useEffect(() => {
    EditQty({ idIndex: index, qty: qty });
  }, [qty]);
  useEffect(() => {
    if (item) {
      setQty(item.qtyCard.qty);
    } else {
      setQty(item.qtyCard.qty);
    }
  }, []);
  return (
    <div
      style={{
        width: "100%",
        height: 90,
        // borderRadius: 10,
        backgroundColor: BlackAndWhite.secondary,
        marginTop: index === 0 ? 3 : 2,
        // WebkitBoxShadow: "0px 0px 7px 2px #00000050",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ marginLeft: 10, marginRight: 5 }}>
        <img alt="icon" style={{ height: 50 }} src={item.product.imageUrl} />
      </div>
      <div style={{ fontSize: 12, width: 170, height: 50 }}>
        {NameAssemble({ product: item.product })}
      </div>
      <div
        style={{
          marginLeft: 10,
          marginRight: 10,
          display: "flex",
          flexDirection: "column",
          width: 100,
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 10,
            fontWeight: "bold",
            opacity: 0.6,
            marginTop: 5,
          }}
        >
          PRICE
        </div>
        <div style={{ marginTop: 5, marginBottom: 17 }}>
          {item
            ? "R " +
              (
                Number(item.product.retailPriceInc) * Number(item.qtyCard.qty)
              ).toFixed(2)
            : null}
        </div>
      </div>
      <div
        style={{
          marginLeft: 10,
          marginRight: 25,
          marginBottom: 15,
          position: "relative",
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"-"}
          mini={true}
          size={30}
          height={30}
          fontWeight={"bold"}
          fontSize={20}
          onClick={() => {
            setQty(Number(qty - 1));
          }}
        />
        <TextInputField
          isDisplay={true}
          value={qty}
          mini={true}
          size={30}
          labelTitle={"Qty"}
          height={10}
          invert={true}
          type={"number"}
          onChange={(e) => {
            setQty(e.target.value);
          }}
        />
        <BaseButtons
          label={"+"}
          mini={true}
          size={30}
          height={30}
          fontWeight={"bold"}
          fontSize={20}
          onClick={() => {
            setQty(Number(qty + 1));
          }}
        />
      </div>

      {/* <BaseButtons
        label={"UPDATE"}
        mini={true}
        marginTopFalse={true}
        borderRadius={8}
        size={80}
        height={30}
        onClick={() => {
          EditQty({ idIndex: index, qty: qty });
        }}
      /> */}
      <div style={{ marginRight: 0 }}>
        <BaseButtons
          label={"X"}
          mini={true}
          marginTopFalse={true}
          // borderRadius={8}
          size={40}
          height={70}
          onClick={() => {
            AddBackToProducts(item.product);
            removeFromRecipets(index);
          }}
          fontWeight={"bold"}
        />
      </div>
    </div>
  );
};

export default CartItem;
